import React, { createContext, useContext, useState } from 'react';

import {
  defaultFilters as initialDefaultFilters,
  values as initialValues,
} from 'components/Helper/DiagnosisFilter/utils/defaultFilters';

interface FilterContextProps {
  defaultFilters: any;
  values: any;
}

const CandidateDiagnosticFilterContext = createContext<FilterContextProps | undefined>(undefined);

export const CandidateDiagnosticFilterProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [defaultFilters, setDefaultFilters] = useState(initialDefaultFilters);
  const [values, setValues] = useState(initialValues);

  return (
    <CandidateDiagnosticFilterContext.Provider value={{ defaultFilters, values }}>
      {children}
    </CandidateDiagnosticFilterContext.Provider>
  );
};

export const useCandidateDiagnosticFilterContext = (): FilterContextProps => {
  const context = useContext(CandidateDiagnosticFilterContext);
  if (!context) {
    throw new Error(
      'useCandidateDiagnosticFilterContext must be used within a CandidateDiagnosticFilterProvider'
    );
  }
  return context;
};
